import { dataReportCheckSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconReportCheckSolid = /*#__PURE__*/createIcon(dataReportCheckSolid)
export default IconReportCheckSolid
